import { render, staticRenderFns } from "./todayTopic.vue?vue&type=template&id=48f00572&scoped=true&"
import script from "./todayTopic.vue?vue&type=script&lang=js&"
export * from "./todayTopic.vue?vue&type=script&lang=js&"
import style0 from "./todayTopic.vue?vue&type=style&index=0&id=48f00572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f00572",
  null
  
)

export default component.exports